// Get the appropriate dashboard route based on user role
export const getDashboardRouteForRole = (role: string | undefined): string => {
  switch (role) {
    case 'super_admin':
      return '/super-admin/dashboard';
    case 'agency_admin':
      return '/agency/dashboard';
    case 'supervisor':
      return '/supervisor/dashboard';
    case 'patient':
      return '/patient/dashboard';
    default:
      return '/patient/dashboard';
  }
};
